import { copyGroup, moveGroup } from '../../apis/GroupAPI';

export const COPY_GFC_BRAND = 'COPY_GFC_BRAND';
export const MOVE_GFC_BRAND = 'MOVE_GFC_BRAND';

export const copyGFCBrand = (
  brandId,
  targetChannelId,
  newName,
  copyContent = true
) => ({
  type: COPY_GFC_BRAND,
  api: copyGroup(brandId, targetChannelId, newName, copyContent)
});

export const moveGFCBrand = (brandId, targetChannelId) => ({
  type: MOVE_GFC_BRAND,
  api: moveGroup(brandId, targetChannelId)
});
